export default function Header() {
  return (
    <div className="xpb-header">
      <div className="xpb-header__hero">
          <h2>
            Cambiemos <br />
          <span>la narrativa</span>
          </h2>
        <div>
          <p>
            Paso a paso para responder al aumento de xenofobia en América Latina y
            el Caribe
          </p>
        </div>
      </div>
    </div>
  );
}
